import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canAccessCustomerPortal, hasAnyPermission, isCustomerUser, isInternalUser, isSuperadminOrDeveloper } from './permissions';
import { useAuth } from './AuthContext';
import { LoadingState } from '../components/LoadingState';

export function ProtectedRoute({
  internalOnly = false,
  customerOnly = false,
  portalAccess = false,
  superadminOrDeveloperOnly = false,
  requiredPermissions = [],
}) {
  const { session, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (internalOnly && isCustomerUser(session)) {
    return <Navigate to="/portal" replace />;
  }

  if (customerOnly && isInternalUser(session)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  if (portalAccess && !canAccessCustomerPortal(session)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  if (superadminOrDeveloperOnly && !isSuperadminOrDeveloper(session)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  if (requiredPermissions.length > 0 && !hasAnyPermission(session, requiredPermissions)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
